/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.SalesRankings {

    interface IServiceSubCatCriteria {
        catId?: Guid
    }
    interface IServiceCriteria {
        serviceCategoryId?: Guid,
        serviceSubCategoryId?: Guid
    }
    interface IProductSubCatCriteria {
        catId?: Guid
    }
    interface IProductCriteria {
        productCategoryId?: Guid,
        productSubCategoryId?: Guid,
        manufacturerId?: Guid,
        distributorId?: Guid
    }
    interface IGiftCardCriteria {
        giftCardTypeId?: Guid
    }
    interface IMembershipCriteria {
        membershipTypeId?: Guid,
        membershipId?: Guid
    }
    interface IPackageCriteria {
        packageId?: Guid
    }

    class ModalAdvancedSearchController {

        static $inject = [
            "$mdDialog",
            "itemFilter",
            "showFilter",
            "defaultCriteria",
            "isEmployeeFilter",
            "employeesList"
        ];

        public criteria: any;
        public showTableColumns: any = {
            giftCards: false,
            memberships: false,
            packages: false,
            products: false,
            services: false
        };
        public serviceSubCatCriteria: IServiceSubCatCriteria;
        public serviceCriteria: IServiceCriteria;
        public productSubCatCriteria: IProductSubCatCriteria;
        public productCriteria: IProductCriteria;
        public giftCardCriteria: IGiftCardCriteria;
        public membershipCriteria: IMembershipCriteria;
        public packageCriteria: IPackageCriteria;

        public defaultServiceCatId: Guid;
        public defaultServiceSubCatId: Guid;
        public defaultServiceId: Guid;

        public defaultDistributorId: Guid;
        public defaultManufacturerId: Guid;
        public defaultProductCatId: Guid;
        public defaultProductSubCatId: Guid;
        public defaultProductId: Guid;

        public defaultGiftCardTypeId: Guid;

        public defaultMembershipTypeId: Guid;
        public defaultMembershipId: Guid;

        public defaultPackageId: Guid;

        public isApplyDisabled: boolean = true;
        public showFilterEnum: any = ShowFilterEnum;
        public employees: any = [];

        public isEmployeesExist: boolean;

        constructor(
            protected $mdDialog: angular.material.IDialogService,
            public itemFilter: number,
            public showFilter: number,
            public defaultCriteria: any,
            public isEmployeeFilter: boolean,
            public employeesList: any
        ) {
            // Show services or products filters
            switch (this.itemFilter) {
                case ItemFilterEnum.GiftCards:
                    this.showTableColumns.giftCards = true;
                    break;
                case ItemFilterEnum.Memberships:
                    this.showTableColumns.memberships = true;
                    break;
                case ItemFilterEnum.Packages:
                    this.showTableColumns.packages = true;
                    break;
                case ItemFilterEnum.Products:
                    this.showTableColumns.products = true;
                    break;
                case ItemFilterEnum.Services:
                    this.showTableColumns.services = true;
                    break;
                case ItemFilterEnum.ProductsServices:
                    this.showTableColumns.products = true;
                    this.showTableColumns.services = true;
                    break;
            }

            // If we have some data for filtering
            if (defaultCriteria) {
                this.defaultServiceCatId = defaultCriteria.serviceCategory && defaultCriteria.serviceCategory.id;
                this.defaultServiceSubCatId = defaultCriteria.serviceSubCategory && defaultCriteria.serviceSubCategory.id;
                this.defaultServiceId = defaultCriteria.service && defaultCriteria.service.id;

                this.defaultDistributorId = defaultCriteria.distributor && defaultCriteria.distributor.id;
                this.defaultManufacturerId = defaultCriteria.manufacturer && defaultCriteria.manufacturer.id;
                this.defaultProductCatId = defaultCriteria.productCategory && defaultCriteria.productCategory.id;
                this.defaultProductSubCatId = defaultCriteria.productSubCategory && defaultCriteria.productSubCategory.id;
                this.defaultProductId = defaultCriteria.product && defaultCriteria.product.id;

                this.defaultGiftCardTypeId = defaultCriteria.giftCardType && defaultCriteria.giftCardType.id;

                this.defaultMembershipTypeId = defaultCriteria.membershipType && defaultCriteria.membershipType.id;
                this.defaultMembershipId = defaultCriteria.membership && defaultCriteria.membership.id;

                this.defaultPackageId = defaultCriteria.package && defaultCriteria.package.id;
            }

            if (employeesList) {
                this.employees.employeeIds = employeesList;
            }

            this.isEmployeesExist = (employeesList || []).length === 0;
        }

        apply = () => {
            this.$mdDialog.hide({
                criteria: this.criteria,
                employees: this.employees.employeeIds
            });
        };

        cancel = () => {
            this.$mdDialog.cancel();
        };

        // Criterias for typeaheads
        public criteriaChanged(): void {
            this.serviceSubCatCriteria = {
                catId: this.criteria.serviceCategory && this.criteria.serviceCategory.id
            };
            this.serviceCriteria = {
                serviceCategoryId: this.criteria.serviceCategory && this.criteria.serviceCategory.id,
                serviceSubCategoryId: this.criteria.serviceSubCategory && this.criteria.serviceSubCategory.id
            };
            this.productSubCatCriteria = {
                catId: this.criteria.productCategory && this.criteria.productCategory.id
            };
            this.productCriteria = {
                productCategoryId: this.criteria.productCategory && this.criteria.productCategory.id,
                productSubCategoryId: this.criteria.productSubCategory && this.criteria.productSubCategory.id,
                manufacturerId: this.criteria.manufacturer && this.criteria.manufacturer.id,
                distributorId: this.criteria.distributor && this.criteria.distributor.id
            };
            this.giftCardCriteria = {
                giftCardTypeId: this.criteria.giftCardType && this.criteria.giftCardType.id
            };
            this.membershipCriteria = {
                membershipTypeId: this.criteria.membershipType && this.criteria.membershipType.id,
                membershipId: this.criteria.membership && this.criteria.membership.id
            };
            this.packageCriteria = {
                packageId: this.criteria.package && this.criteria.package.id
            };

            this.isApplyDisabled = !this.criteria;
        }

        // on change employee
        public changeEmployeesList(): void {
            if (this.criteria) {
                this.isApplyDisabled = false;
            } else {
                if (this.employees.employeeIds) {
                    this.isApplyDisabled = this.employees.employeeIds.length > 0 && false;
                } else {
                    this.isApplyDisabled = true;
                }
            }
        }
    }

    angular.module("meevo.plugins.salesRankings")
        .controller("meevo.plugins.salesRankings.ModalAdvancedSearchController", ModalAdvancedSearchController);
}